export default __webpack_public_path__ + "static/controladoria2-30bdbad826b55f0b4dff7e833938f601.jpeg";